import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $accountByIdStore } from '@lib/store/accounts';
import { Requisites } from './requisites';

export const Details = () => {
  const { data } = useUnit($accountByIdStore.store);

  const requisites = useMemo(
    () => [
      { name: 'Account label', value: data?.accountLabel || '-' },
      { name: 'Cost centre', value: data?.costCentre || '-' },
      { name: 'Beneficiary', value: data?.beneficiaryName || '-' },
      { name: 'IBAN', value: data?.iban || '-' },
      { name: 'BIC/Swift code', value: data?.bicOrSwiftCode || '-' },
      { name: 'Corresponding bank BIC', value: data?.corrBank || '-' },
      {
        name: 'Bank name and address',
        value: data?.bankName + ' ' + data?.bankAddress,
      },
    ],
    [data],
  );

  return <Requisites data={data} values={requisites} />;
};
